import { render } from "./AppSidebarNavs.vue?vue&type=template&id=516b4266"
import script from "./AppSidebarNavs.vue?vue&type=script&lang=js"
export * from "./AppSidebarNavs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/krisflajs/Projects/DDStudios/DDS-platform/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__